import Vue from 'vue'

import CoreuiVue from "@coreui/vue"

Vue.use(CoreuiVue)